import type {ReactElement} from 'react';
import React from 'react';
import styles from './cursor-overlay.module.scss';
import {useAppSelector} from '@/hooks';
import {CURSOR_OVERLAY_CONTAINER_ID} from '@Components/poster-editor/components/cursor-overlay/cursor-overlay.types';

export function CursorOverlay(): ReactElement<any> {
  const isPickingModeEnabled = useAppSelector((state) => {
    return state.posterEditor.isPickingModeEnabled;
  });
  const areStylesCopied = useAppSelector((state) => {
    return state.posterEditor.copiedStyles;
  });

  return (
    <div
      id={CURSOR_OVERLAY_CONTAINER_ID}
      className={`${styles.container} ${areStylesCopied ? styles.pasteStyleCursor : isPickingModeEnabled ? styles.colorPickerCursor : styles.displayNone}`}
    />
  );
}
